<template>
  <ul class="stepper">
    <li
      v-for="(stepName, index) in steps"
      :key="index"
      :class="{ active: index + 1 === step }"
      class="stepper__item"
    >
      <div class="stepper__item--index">
        <span>{{ index + 1 }}</span>
      </div>
      <div class="stepper__item--title">
        {{ stepName }}
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true
    },
    step: {
      type: Number,
      required: true
    }
  },
  watch: {
    $props: {
      immediate: true,
      handler() {
        this.validateProps()
      }
    }
  },
  methods: {
    validateProps() {
      if (this.step > this.steps.length || this.step <= 0) {
        console.error('invalid step')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.stepper {
  width: 100%;
  display: flex;
  justify-content: space-between;

  &__item {
    display: flex;
    flex: 1;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    gap: 8px;
    position: relative;

    &--index {
      width: 24px;
      height: 24px;
      font-size: 1.4rem;
      font-weight: 700;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $white;
      background-color: $gray-2;
      border-radius: 50%;
      box-sizing: border-box;
      z-index: 1;
    }
    .active > &--index {
      background-color: $black;
      color: $white;
    }

    &--title {
      width: 72px;
      font-size: 1rem;
      color: $gray-1;
      text-align: center;
      text-align: center;
      line-height: 1.6;
      white-space: pre-wrap; // Step名に「\n」を入れることで見た目上、改行させるためのもの
    }
  }

  &__item + &__item::before {
    display: block;
    position: absolute;
    top: 12px;
    left: -50%;
    content: '';
    width: 100%;
    height: 2px;
  }

  &__item::before {
    background-color: $gray-2;
  }
}
</style>
